const initialState = {
    open_login_dialog: null,
};

import { getField, updateField } from 'vuex-map-fields';

export const params = {
    namespaced: true,
    state: initialState,
    getters: {
        getField,
    },
    mutations: {
        updateField,
    },
};